import { ChipGroup } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const FilterButtonsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('200')};

    // Purpur ChipGroup root element does not accept custom classes, but passed it down one element
    & > [class*='purpur-chip-group--container'] {
        display: contents;
    }
`;

export const FiltersChipGroup = styled(ChipGroup)`
    display: contents;
    [class*='_purpur-chip-group-item__checkmark-icon'] {
        flex-shrink: 0;
    }
`;
